<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-18 17:58:06
-->
<template>
  <veStuMoralActive viewType="admin" slot="table"></veStuMoralActive>
</template>

<script>
import veStuMoralActive from './base/veStuMoralActive';
export default {
  components: {
    veStuMoralActive
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped></style>
